const MuiDateCalendar = {
  styleOverrides: {
    root: {
      width: "328px"
    }
  }
};
export {
  MuiDateCalendar
};
